export const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop)

export const expandSectionHandler = (expandedItems, setExpandedItems, someRef) => {
  if (expandedItems) {
    scrollToRef(someRef)
  }
  setExpandedItems(!expandedItems)
}
